import { render, staticRenderFns } from "./unbindStudentView.vue?vue&type=template&id=0f93f67e&"
import script from "./unbindStudentView.vue?vue&type=script&lang=js&"
export * from "./unbindStudentView.vue?vue&type=script&lang=js&"
import style0 from "./unbindStudentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports